import { useState, useRef } from 'react'

interface ValidationRules {
  [key: string]: (value: unknown) => string | undefined
}

export const useFormValidation = (validationRules: ValidationRules) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({})
  const prevValuesRef = useRef<{ [key: string]: unknown }>({})

  const validate = (values: { [key: string]: unknown }) => {
    const newErrors: { [key: string]: string } = {}
    Object.keys(validationRules).forEach(key => {
      const error = validationRules[key](values[key])
      if (error) {
        newErrors[key] = error
      }
    })
    setErrors(newErrors)
    prevValuesRef.current = values
    return newErrors
  }

  const clearError = (key: string) => {
    setErrors(prevErrors => {
      const { [key]: omitted, ...rest } = prevErrors
      return rest
    })
  }

  const handleValueChange = (values: { [key: string]: unknown }) => {
    Object.keys(values).forEach(key => {
      if (values[key] !== prevValuesRef.current[key]) {
        clearError(key)
      }
    })
    prevValuesRef.current = values
  }

  return { errors, validate, handleValueChange }
}
